// extracted by mini-css-extract-plugin
export var animationContainer = "_gn-0";
export var asteriskIcon = "_gn-8";
export var conversationLeftSection = "_gn-4";
export var conversationListItem = "_gn-3";
export var conversationMiddleSection = "_gn-5";
export var conversationRightSection = "_gn-6";
export var detailsContent = "_gn-1";
export var listContainer = "_gn-7";
export var modalContent = "_gn-2";